import {  withDatasourceCheck, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

type QyiasProps = ComponentProps & {
  fields: {
    Title: {
      value: string
    }
    Description: {
      value: string
    },
    SubTtitle: {
      value: string
    },
    SubDescription: {
      value: string
    }

  };
  locale:string
};

const Qyias = (props: QyiasProps): JSX.Element => (
  <div className={`responsive pt-40 ${props?.locale=="ar"?'rtl':''}`}>
    <div className="flex flex-col lg:gap-7 gap-3">
      <h1 className='text-[42px] text-brand-100 font-bold animate-top-dga'>{props.fields.Title.value}</h1>
      <RichText className="text-[#5E5E5EFC] text-[18px] font-normal animate-top-dga" field={props.fields.Description} />
      <h1 className='text-[28px] text-[#003141] font-bold animate-top-dga'>{props.fields.SubTtitle.value}</h1>
      <RichText className="text-[#5E5E5EFC] text-[18px]  font-normal animate-top-dga" field={props.fields.SubDescription} />
    </div>
  </div>
);


export default withDatasourceCheck()<QyiasProps>(Qyias);
